import React from 'react'

const OurTeam = () => {
    return (
        <>

            {/* <div className="team-area py-120" style={{marginTop:"-210px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline"><i className="far fa-book-open-reader" /> Our Teachers</span>
                                <h2 className="site-title">Meet With Our <span>Teachers</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <img src="assets/school/Teachers.webp" className="img-fluid" alt="team member" style={{borderRadius:"20px"}} />
                    </div>
                </div>
            </div> */}

            <div className="team-area py-120" style={{ marginTop: "-210px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline"><i className="far fa-book-open-reader" /> Our Teachers</span>
                                <h2 className="site-title">Meet With Our <span>Teachers</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {/* <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Miss Shreya singh.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Miss. Shreya singh</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div> */}
                        <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Mrs. Anita Chauhan.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Mrs. Anita Chauhan</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Mrs. Mala Singh.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Mrs. Mala Singh</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Mrs. Neelu Singh Parihar.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Mrs. Neelu Singh Parihar</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Mrs. Neetu Singh.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Mrs. Neetu Sen</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Mrs. Olip Das.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Mrs. Olip Das</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Mrs. Sapna Sharma.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Mrs. Sapna Sharma</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="team-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="team-img">
                                    <img src="assets/school/Mrs. Vibha Singh.webp" alt="thumb" />
                                </div>
                                <div className="team-social">
                                    <a href="/"><i className="fab fa-facebook-f" /></a>
                                    <a href="/"><i className="fab fa-whatsapp" /></a>
                                    <a href="/"><i className="fab fa-linkedin-in" /></a>
                                    <a href="/"><i className="fab fa-youtube" /></a>
                                </div>
                                <div className="team-content">
                                    <div className="team-bio" style={{textAlign:"center"}}>
                                        <h5><a to="teacher-single.html">Mrs. Vibha Singh</a></h5>
                                        <span style={{textAlign:"center"}}>Teachers</span>
                                    </div>
                                </div>
                                <span className="team-social-btn"><i className="far fa-share-nodes" /></span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>




        </>
    )
}

export default OurTeam